import React from 'react';
import Typography from '@material-ui/core/Typography';

const EmptyMessage = () => {
    return (
        <Typography
            variant="body2"
            style={{
                display: 'grid',
                placeItems: 'center',
                height: '400px',
                color: 'gray',
            }}
        >
            no events found
        </Typography>
    )
}

export default EmptyMessage
